import { motion, useInView } from "framer-motion";
import { useRef } from "react";

const products = [
  {
    name: "Aether Capsule",
    tag: "AC_V2",
    description: "Immersive neural-restoration pod with Local AI Avatar.",
    image:
      "https://customer-assets.emergentagent.com/job_dd0ec9e6-d029-446f-878a-3ab89018bda2/artifacts/bc2c63zf_AC_V2.jpeg",
    hasImage: true,
  },
  {
    name: "LunaCalma",
    tag: "LC_V2",
    description: "Wearable haptic interface for remote emotional connection.",
    image:
      "https://hd0bixuivnzinxhh.public.blob.vercel-storage.com/luna-calma.png.webp",
    hasImage: true,
  },
  {
    name: "OASIS Terminal",
    tag: "OT_1",
    description: "High-tech 'Intellectual Detox' hubs.",
    image:
      "https://customer-assets.emergentagent.com/job_dd0ec9e6-d029-446f-878a-3ab89018bda2/artifacts/00a30nsg_OT_1.png",
    hasImage: true,
  },
];

const EcosystemSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section
      id="ecosystem"
      data-testid="ecosystem-section"
      ref={ref}
      className="relative z-10 py-24 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.7 }}
          className="text-center mb-16 lg:mb-20"
        >
          <p className="text-xs font-semibold tracking-[0.3em] uppercase text-cyanGlow mb-4">
            The Ecosystem
          </p>
          <h2 className="metallic-text text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight">
            Multimodal Physical AI
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8">
          {products.map((product, i) => (
            <motion.div
              key={product.name}
              initial={{ opacity: 0, y: 40 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.7, delay: 0.2 + i * 0.15 }}
              data-testid={`product-card-${product.tag.toLowerCase()}`}
              className="glass-card rounded-2xl overflow-hidden group"
            >
              {/* Image */}
              <div className="product-image-wrap aspect-[4/3] relative">
                {product.hasImage ? (
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                    loading="lazy"
                  />
                ) : (
                  <div className="w-full h-full placeholder-shimmer flex items-center justify-center">
                    <div className="text-center">
                      <div className="w-16 h-16 mx-auto rounded-full border border-cyanGlow/30 flex items-center justify-center mb-3">
                        <svg
                          width="32"
                          height="32"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#00f0ff"
                          strokeWidth="1.5"
                          className="opacity-60"
                        >
                          <circle cx="12" cy="12" r="3" />
                          <path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" />
                        </svg>
                      </div>
                      <p className="text-xs text-zinc-500 tracking-widest uppercase">
                        Coming Soon
                      </p>
                    </div>
                  </div>
                )}
              </div>

              {/* Content */}
              <div className="p-6 lg:p-8">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-[10px] font-bold tracking-widest uppercase text-cyanGlow/70 border border-cyanGlow/20 px-2 py-0.5 rounded-full">
                    {product.tag}
                  </span>
                </div>
                <h3 className="text-xl lg:text-2xl font-bold text-offWhite tracking-tight">
                  {product.name}
                </h3>
                <p className="mt-2 text-sm text-zinc-400 leading-relaxed font-light">
                  {product.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EcosystemSection;
